import { createSelector } from 'reselect';
import { ReduxState } from '../state';
import { CourseMarketingFilterState, INITIAL_STATE } from './state';
import { selectInstitutionValues } from '../../web/containers/CoursesPage/selectors';
import { InstitutionSummary } from '../Institutions/types';

const selectState = (state: ReduxState): CourseMarketingFilterState =>
  state.CourseMarketingFilter || INITIAL_STATE;

export const selectFeaturedInstitutions = createSelector(
  selectState,
  (state) => state.featuredInstitutions
);

export const selectFeaturedCourses = createSelector(
  selectState,
  (state) => state.featuredCourses
);

export const selectCategories = createSelector(
  selectState,
  (state) => state.categories
);

export const selectCourseTypes = createSelector(
  selectState,
  (state) => state.courseTypes
);

export const selectInstitutionFromQuery = createSelector(
  selectInstitutionValues,
  selectFeaturedInstitutions,
  (filters, featuredInstitutions) => {
    const selectedInstitutions: InstitutionSummary[] = [];
    featuredInstitutions.forEach((institution) => {
      if (filters.includes(institution.path)) {
        selectedInstitutions.push(institution);
      }
    });
    return selectedInstitutions;
  }
);
